import { render } from "./UiStatusIndicator.vue?vue&type=template&id=16c04040&scoped=true&ts=true"
import script from "./UiStatusIndicator.vue?vue&type=script&lang=ts"
export * from "./UiStatusIndicator.vue?vue&type=script&lang=ts"

import "./UiStatusIndicator.vue?vue&type=style&index=0&id=16c04040&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c04040"]])

export default __exports__